import { Component, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { ImportWizardUploadService } from '../service/import-wizard-upload.service';
import { ErzeugungsanlagenImportReport } from '../model/erzeugungsanlagen-import-report';
import { ImportWizardDialogService } from '../service/import-wizard-dialog.service';
import { ErzeugungsanlagenRefreshService } from '../../service/erzeugungsanlage/erzeugungsanlagen-refresh.service';
import { MatStepper } from '@angular/material/stepper';
import { ErzeugungsanlageImportJob, initialImportJob } from '../../domain/model/erzeugungsanlage-import-job';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';

@Component({
    selector: 'tnb-import-wizard',
    templateUrl: './import-wizard.component.html',
    styleUrls: [
        './import-wizard.component.scss',
    ],
    standalone: false,
})
export class ImportWizardComponent {
    private uploadService = inject(ImportWizardUploadService);
    private erzeugungsanlagenRefreshService = inject(ErzeugungsanlagenRefreshService);
    importWizardDialogService = inject(ImportWizardDialogService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild('stepper', { static: true })
    public stepper: MatStepper;

    public loading = false;
    public selectedFile?: File;
    public jobId?: number;
    public importReport: ErzeugungsanlagenImportReport = null;
    public backendFailure: any = null;
    public job: ErzeugungsanlageImportJob;

    private jobCheckerTimeout: any;

    handleFileChange(selectedFile?: File): void {
        this.selectedFile = selectedFile;
    }

    async upload(dryRun: boolean) {
        this.loading = true;
        this.importReport = null;
        this.job = initialImportJob;
        this.backendFailure = null;
        try {
            const result = await this.uploadService.uploadExcelAsync(
                this.teilgebietSelectionService.getSelectedStadtwerkeId(),
                this.selectedFile,
                dryRun,
            ) as any;
            this.jobId = result.body.jobId;
            this.jobCheckerTimeout = setInterval(() => this.checkJobDone(dryRun), 756);
            this.stepper.next();
        } finally {
            this.loading = false;
        }
    }

    private async checkJobDone(dryRun: boolean) {
        try {
            this.job = await this.uploadService.checkImportJob(this.jobId);
            this.changeDetectorRef.markForCheck();
            if (this.job.done) {
                if (this.job.report) {
                    setTimeout(() => { // typically the finalization is so quick that the user doesn't see all of the checkboxes green,
                        // so the timeout is just for the feel :)
                        this.importReport = JSON.parse(this.job.report);
                        this.changeDetectorRef.markForCheck();
                        clearInterval(this.jobCheckerTimeout);
                    }, 842);
                    if (!dryRun) {
                        this.erzeugungsanlagenRefreshService.requestRefresh();
                    }
                }
            }
        } catch (e) {
            clearInterval(this.jobCheckerTimeout);
            this.backendFailure = e;
        }
    }

    close(): void {
        this.importWizardDialogService.close();
    }

}
